import { ObjectType, PageObject } from "../types";
import { slugifyString } from "../../utils/slugifyString";
import { prettifyString } from "../../utils/prettifyString";

type BuildPageObject = (currentPath?: string) => PageObject;

const buildPageObject: BuildPageObject = (currentPath) => {
  const pagePath = currentPath || window.location.pathname;
  const formattedPagePath = pagePath.replace(/\/+$/, "") || "/";

  const prettyfiedPagePath = prettifyString(formattedPagePath);
  const slugifiedPagePath = slugifyString(formattedPagePath);

  const pageId = slugifiedPagePath ? `page:${slugifiedPagePath}` : "page:root";
  const pageName = prettyfiedPagePath ? prettyfiedPagePath : "Root";

  return {
    type: ObjectType.Page,
    id: pageId,
    name: pageName,
    path: formattedPagePath,
  };
};

export { buildPageObject };
